export class ReassessActionRequiredResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowTriggered",
            "baseName": "workflowTriggered",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReassessActionRequiredResponse.attributeTypeMap;
    }
    constructor() {
    }
}
